
// const apiKey = (window._env_ && window._env_.FIREBASE_API_KEY) || defaultApiKey;
// const appId = (window._env_ && window._env_.FIREBASE_APP_ID) || defaultAppId;
const firebaseConfig = {
  apiKey: "AIzaSyDl8R22u1-EN2uIqQbgLVg3ylVf1C4v1bE",
  authDomain: "safe-649c4.firebaseapp.com",
  projectId: "safe-649c4",
  storageBucket: "safe-649c4.appspot.com",
  messagingSenderId: "191963884767",
  appId: "1:191963884767:web:808121b95a4db024a84d6a"
};

export default firebaseConfig;